import backgroundImage from '@assets/images/bg.png';
import { AREA_HEIGHT, AREA_WIDTH, CASTLE_WIDTH, CELL_SIZE, TOOLBAR_HEIGHT, } from '@static/game';
import { Cell } from './Cell';
import { GameConfiguratorSingleton } from '@services/GameConfiguratorSingleton';
var Grid = /** @class */ (function () {
    function Grid() {
        var _this = this;
        this.prepareGrid = function () {
            for (var y = TOOLBAR_HEIGHT; y < AREA_HEIGHT; y += CELL_SIZE) {
                for (var x = CASTLE_WIDTH; x < AREA_WIDTH; x += CELL_SIZE) {
                    _this._gameGrid.push(new Cell(x, y));
                }
            }
        };
        this.draw = function () {
            var context = GameConfiguratorSingleton.getInstance().context;
            context.drawImage(_this._backgroundImage, 0, 0, 900, 600);
            _this._gameGrid.forEach(function (cell) {
                cell.draw();
            });
        };
        this._gameGrid = [];
        this.prepareGrid();
        this._backgroundImage = new Image();
        this._backgroundImage.src = backgroundImage;
    }
    return Grid;
}());
export { Grid };
